/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
import * as e from "react";
import t from "prop-types";
import { focusFirstFocusableChild as u, classNames as f } from "@progress/kendo-react-common";
const c = e.forwardRef((o, n) => {
  const { children: l, className: a, style: m } = o, s = e.useRef(null), r = e.useCallback(() => {
    s.current && u(s.current);
  }, []), p = e.useCallback(
    () => ({
      element: s.current,
      focus: r
    }),
    [r]
  );
  e.useImperativeHandle(n, p);
  const i = e.useMemo(() => f("k-appbar-section", a), [a]);
  return /* @__PURE__ */ e.createElement("div", { className: i, style: m }, l);
});
c.propTypes = {
  children: t.any,
  className: t.string,
  style: t.object
};
c.displayName = "KendoAppBarSection";
export {
  c as AppBarSection
};
